export const formatBetaPageUrl = (siteUrl: string | null | undefined, route?: string | null) => {
    if (!route) return null
    if (/^https?:\/\//i.test(route) || route.startsWith('//')) return route
    if (!siteUrl) return null

    const base = /^https?:\/\//i.test(siteUrl) || siteUrl.startsWith('//')
        ? siteUrl
        : `//${siteUrl}`

    return `${base.replace(/\/$/, '')}/${route.replace(/^\//, '')}`
}
